/**
 * Parses text up to 2 words after an "@" character to identify a likely search term.
 */
const parseLikelySearchTerm = (text: string): string | null => {
	const atIndex = text.lastIndexOf("@");
	if (atIndex === -1) return null;
	const afterAt = text.slice(atIndex + 1).trim();
	const words = afterAt.split(/\s+/);
	if (words.length > 2) return null;
	return words.length > 0 ? words.join(" ") : null;
};
export default parseLikelySearchTerm;
